/**
 * Copyright (c) eventlint. All Rights Reserved.
 *
 *
 * @summary
 * @author Segev {CJ} Shmueli <cj@segevs.com>
 *
 * Created: 7/1/2022
 */

import { Button } from "@mui/material";
import DownloadIcon from '@mui/icons-material/Download';
import {
    analytics
} from '../config';
import {
    logEvent
} from 'firebase/analytics';



const Presentation = () => {
    const handleDownload = () => {
        const version = "https://storage.googleapis.com/eventlint.appspot.com/presentation-material/deck-june-2022.pdf";

        logEvent(analytics, "download_presentation", {
            version
        });

        window.open(version, "_blank");

    }
    return (
        <>
            <div className='hero'>
                <h1>Investor Presentation</h1>
            </div>

            <main>
                <div>
                    <iframe
                        title="presentation"
                        src="https://docs.google.com/presentation/d/e/2PACX-1vRKR-lpccXQZRlgfp4r5FkPpfPvaipqY-hh2cmVM9QWflji_b1dx9dc4gRCMjeBL-KbRy-C5yMEOA1c/embed?start=false&loop=false&delayms=3000"
                        style={{
                            margin: "auto",
                            width: "99%",
                            maxWidth: "1440px",
                            height: "720px",
                        }}></iframe>
                </div>
                <div className="text-center p-8">

                    <Button onClick={handleDownload} className='flex items-center gap-3' variant="contained">
                        <DownloadIcon />
                        Download
                    </Button>
                </div>
            </main>
        </>
    );
}

export default Presentation;